import { FC } from 'react'
import { useTranslation } from 'next-i18next'
import { PrimaryHeading } from '../../atoms/PrimaryHeading'
import { ICompanyBase } from '../../../types'
import { CompanyOverviewItemList } from '../CompanyOverviewItemList'

type Props = {
  company: ICompanyBase
}

export const CompanyProfileOverview: FC<Props> = ({ company }) => {
  const { t } = useTranslation(['companies-users-[id]'])
  return (
    <div>
      <PrimaryHeading backgroundText='OVERVIEW' htmlTagType='h2'>
        {t('基本情報')}
      </PrimaryHeading>
      <CompanyOverviewItemList company={company} />
    </div>
  )
}
